export const translations = {
  fi: {},
  en: {
    navbar: {
      language: {
        switchToEnglish: 'Switch site language to English',
        switchToFinnish: 'Switch site language to Finnish',
      },
      aria: {
        mainNav: 'Main navigation',
        goHome: 'Go to home page',
      },
      logoAlt: 'TuutoriKeskus logo',
      links: {
        home: 'Home',
        courses: 'Courses',
        romania: 'Romania',
        about: 'About Us',
        contact: 'Contact',
      },
      contact: {
        emailHeading: 'Email',
        phoneHeading: 'Phone',
        socialHeading: 'Social media',
        facebook: 'TuutoriKeskus on Facebook',
        instagram: 'TuutoriKeskus on Instagram',
        youtube: 'TuutoriKeskus on YouTube',
      },
    },
    hamburger: {
      screenReaderLabel: 'Open and close the navigation menu',
      ariaLabel: 'Open or close the main navigation',
    },
    hero: {
      heading: 'The perfect place for your medical journey',
      description: 'A place where we support, guide, and mentor future colleagues pursuing a career in medicine with all our hearts.',
      quote: '"Wherever the art of medicine is loved, there is also a love of humanity." - Hippocrates',
      socials: {
        facebook: 'Follow TuutoriKeskus on Facebook',
        instagram: 'Follow TuutoriKeskus on Instagram',
        tiktok: 'Follow TuutoriKeskus on TikTok',
        whatsapp: 'Contact us on WhatsApp',
      },
    },
    services: {
      heading: 'Our Services',
      cards: {
        courses: {
          title: 'Courses',
          description:
            'Our coaching courses train future colleagues to excel in entrance exams. Our teaching methods and exam tips have proven invaluable on our courses for years.',
        },
        application: {
          title: 'Application Process',
          description:
            'Improve your chances by outsourcing the paperwork to professionals. We submit your application to the university in Romania so you can focus on studying and succeeding in the entrance exam.',
        },
        support: {
          title: 'Customer Support',
          description:
            'Studying abroad raises many questions, and we are here for you. Please contact us if you have questions about our services or about medical studies in Romania.',
        },
      },
    },
    moreInfo: {
      heading: 'Additional Information',
      cards: {
        about: {
          alt: 'TuutoriKeskus team',
          title: 'About Us',
          description:
            'We want to support young people as they choose the most important path in their lives, help them realise their dreams, and create added value for future colleagues.',
          linkAria: 'Read more about us',
        },
        medicine: {
          alt: 'Student in Romania',
          title: 'Medicine in Romania',
          description:
            'The studies are hands-on. The first years focus on theory (pre-clinical phase), while the final three years provide intensive practical experience (post-clinical phase).',
          linkAria: 'Read more about studying medicine in Romania',
        },
        requirements: {
          alt: 'Student preparing for exams',
          title: 'Exam Requirements',
          description:
            'Top universities in Romania do not require chemistry or physics. Entrance exams focus on anatomy and physiology, and the test is primarily oral.',
          linkAria: 'Read more about the exam requirements',
        },
      },
    },
    common: {
      links: {
        readMore: 'Read More',
      },
    },
    timeline: {
      kicker: 'Our achievements year after year',
      heading: 'Our Timeline',
      description: 'We are extremely proud of the success rates of our Super-Guarantee course over the years.',
      aria: {
        list: 'Success rates of the Super-Guarantee course by year',
        item: 'Year {{year}}, {{percentage}} percent',
      },
    },
    contact: {
      heading: 'Contact Us',
      imageAlt: 'Contact us',
      form: {
        placeholders: {
          name: 'Name*',
          email: 'Email*',
          phone: 'Phone',
          subject: 'Subject*',
          message: 'Message*',
        },
        buttons: {
          submitting: 'Sending...',
          sending: 'Sending...',
          submit: 'Send',
        },
        status: {
          success: '✓ Message sent!',
        },
      },
      company: {
        name: 'Tuutorikeskus Oy',
        emailHeading: 'Email',
        phoneHeading: 'Phone',
        social: {
          facebook: 'Follow us on Facebook',
          instagram: 'Follow us on Instagram',
          youtube: 'Follow us on YouTube',
        },
      },
    },
    newsletter: {
      close: 'Close the newsletter subscription dialog',
      heading: 'Subscribe to our newsletter',
      intro: 'Valuable tips and discounts for those interested in studying medicine in Romania.',
      form: {
        emailLabel: 'Email address',
        emailPlaceholder: 'Email address',
        sending: 'Subscribing...',
        submit: 'Subscribe',
        success: '✓ Your subscription has been received!',
      },
      sidebar: {
        title: 'Contents',
        items: {
          fees: 'Tuition fees & Kela benefits',
          legalisation: 'Licensing in Finland & traineeships',
          whyRomania: 'Why Romania & living in Romania',
          requirements: 'Requirements for applying to medical school',
        },
      },
    },
    coursesPage: {
      heading: 'Courses',
      buttons: {
        enroll: 'Enroll',
      },
      cards: {
        intensive: {
          alt: 'Intensive course',
          title: 'Intensive Course',
          duration: '3.5 weeks',
          features: {
            book: 'Course book',
            hours: '54 teaching hours',
            application: 'Assistance with the application process',
            travel: 'We travel with you to Romania',
          },
        },
        super: {
          alt: 'Super course',
          title: 'Super Course',
          duration: '9 weeks',
          features: {
            book: 'Course book',
            hours: '108 teaching hours',
            tutoring: '1 hour of private tutoring',
            material: 'Online materials & assignments',
            application: 'Assistance with the application process',
            travel: 'We travel with you to Romania',
          },
        },
        superGuarantee: {
          alt: 'Super guarantee course',
          title: 'Super Guarantee Course',
          duration: '10 weeks',
          features: {
            book: 'Course book',
            hours: '114 teaching hours + money-back guarantee',
            tutoring: '2 hours of private tutoring',
            material: 'Online materials & assignments',
            application: 'Assistance with the application process',
            travel: 'We travel with you to Romania',
          },
        },
        applicationTravel: {
          alt: 'Application service and travel',
          title: 'Application Service + Travel',
          features: {
            application: 'Assistance with the application process',
            travel: 'We travel with you to Romania',
          },
        },
        application: {
          alt: 'Application service',
          title: 'Application Service',
          features: {
            application: 'Assistance with the application process and submitting the application to the university.',
          },
        },
        knots: {
          alt: 'Surgical course',
          title: 'Knots & Suture',
          features: {
            description: 'Two-day course in Romania covering the theory and practice of surgical fundamentals.',
          },
        },
      },
    },
    enrollment: {
      heading: 'Enrollment',
      actions: {
        close: 'Close the form',
      },
      errors: {
        selectEducation: 'Please choose a qualification.',
        selectCompletion: 'Please choose either "Yes" or "No".',
      },
      form: {
        firstName: 'First name',
        lastName: 'Last name',
        birthdate: 'Date of birth (10.06.1999)',
        email: 'Email',
        phone: 'Phone',
        qualifications: 'Qualifications',
        qualificationsRequired: 'Qualifications*',
        options: {
          vocational: 'Vocational school',
          upperSecondary: 'Upper secondary school',
          matriculation: 'Matriculation examination',
        },
        hasCompleted: 'Have you completed the qualification?',
        choice: {
          yes: 'Yes',
          no: 'No',
        },
        completionDate: 'When did you complete it? (20.09.2022)',
        graduationDate: 'When will you graduate? (20.09.2024)',
        buttons: {
          sending: 'Sending...',
          submit: 'Send',
        },
        success: 'Enrollment accepted',
      },
    },
    romaniaPage: {
      heading: 'Romania',
      video: {
        title: 'Introduction video about Romania',
      },
      sections: {
        medicine: {
          title: 'Medicine in Romania',
          description:
            'The studies are hands-on. The first years focus on theory (pre-clinical phase), while the final three years provide intensive practical experience (post-clinical phase).',
          linkAria: 'Read more about medical studies in Romania',
        },
        exams: {
          title: 'Exam Requirements',
          description:
            'Top universities in Romania do not require chemistry or physics. Entrance exams focus on anatomy and physiology and are mainly oral.',
          linkAria: 'Read more about the exam requirements',
        },
      },
      leisure: {
        heading: 'Leisure Time',
        intro: 'Besides your studies you have time to explore Romania’s famous sights and beautiful nature.',
        sectionTitle: 'Leisure Time in Romania',
        sectionDescription:
          'Romania offers a wide range of hobbies, so everyone can find the right one. Whether you are into films, theatre, restaurants, riding, hiking or boxing, hobbies are very affordable and your student allowance covers them easily.',
        imageAlt: 'Students spending leisure time in Romania',
      },
      holidays: {
        imageAlt: 'Mountain landscape in Romania',
        title: 'Holidays',
        christmas: 'Christmas holiday lasts 2 weeks.',
        winter: 'Winter holiday lasts 1 week.',
        easter: 'Easter holiday lasts 11 days.',
        summer: 'Summer holiday lasts 3 months.',
      },
      hobbies: {
        title: 'Hobbies & cost estimates',
        summary: 'More information about hobbies and their costs.',
        cta: 'Read more',
        modal: {
          close: 'Close additional information form',
          title: 'Hobbies & cost estimates',
          main:
            'For students under 27, a travel card costs €7/month. With a student card you can travel within the country by train for free. Travelling to other European countries from Romania is inexpensive and convenient. Flights to London can cost under £20 and to Spain €10. If you feel homesick, a direct flight from Bucharest to Finland takes just two hours.<br /> <br />There are many great travel destinations within Romania and neighbouring countries that you can reach easily by train or local bus. Sun destinations include the beach and stunning scenery of Constanța. Nightlife lovers enjoy Bucharest, Cluj-Napoca offers impressive art, Sighișoara boasts one of Europe’s best-preserved medieval centres, and the streets are filled with market buzz every weekend.<br /> <br />The Romanian climate is fantastic! As you know, in Finland we get only 2–3 weeks of real heat each year, but in Romania it’s the other way around — warmth lasts all year. At Romanian universities you receive generous holidays if you do your work well. You can even influence the length of your holidays: if you finish your courses without resits, you may start your break a few weeks earlier.',
          additional:
            'Approximate costs of hobbies in Romania:<br />• Gym membership €10/month<br />• Cinema €4<br />• Boxing course €15–20/month<br />• Mixed martial arts course €15–20/month<br />• Restaurants: depending on quality €3–15<br />• Cafés: €2–5<br />• Football, basketball, volleyball, badminton about €15/month<br /><br />Free hobbies include for example:<br />• Football, basketball, tennis on outdoor courts<br />• Libraries<br />• Hiking in Romanian nature and mountains<br />• Guided city tours<br />• School events such as cultural dress days, international food days, or school dances.',
        },
      },
    },
    medicineRomania: {
      hero: {
        heading: 'Medicine in Romania',
        description:
          'Many Finnish students consider continuing their studies abroad. Increasing numbers head to medical universities overseas in search of international opportunities.',
      },
      why: {
        heading: 'Why Romania?',
        introTitle: 'What attracts applicants first?',
        points: {
          acceptanceTitle: 'Excellent admission opportunities',
          acceptanceText: 'Gaining admission to a Romanian medical university is significantly more likely.',
          teachingTitle: 'High-quality, hands-on teaching',
          teachingText: 'Education meets EU standards and focuses more strongly on practical training.',
          tuitionTitle: 'Affordable tuition fees',
          tuitionText:
            'Countries like Estonia, Latvia, and others in Europe may charge double or triple the tuition of other destinations. In Romania tuition fees are around €5,500.',
          costOfLivingTitle: 'Low cost of living suits students well',
          costOfLivingText: 'Because the general cost of living is low, student financial aid covers monthly expenses.',
        },
      },
      moreInfo: {
        title: 'Explore other useful topics such as international friendships and safety.',
        description:
          'Studying medicine in Romania offers much more than just education. Students form meaningful international friendships while enjoying a safe environment. This combination makes the study experience richer and more carefree.',
        button: 'Read More',
      },
      modal: {
        close: 'Close additional information form',
        friendsTitle: 'International study friends',
        friendsText:
          'When you apply to a Romanian medical university, you are ready to begin a new chapter in a foreign country. You can be sure that your social network will grow during your studies and you will build lasting relationships with fellow students. Universities welcome students from all over the world: America, Asia, Africa and Europe. During and after your studies you will be able to create international connections. The number of Finnish students is large and keeps growing every year, with Finns on every year level at the most popular Romanian universities. Annually around 120 Finnish students apply to English-language medical programmes in Romania.',
        safetyTitle: 'Safety',
        safetyText:
          'General safety is an important criterion when moving abroad to study. We examined Romania’s safety situation by interviewing students and reviewing crime statistics. Contrary to our preconceptions, the crime rate is comparable to Finland. Students said they have not encountered problems or dangerous situations, and they noted that the police assist international students. One student told how they left a bag on a bus but, with police help, got it back the same day. If you feel safe in Finland, you will feel equally safe in Romania — students reported that the level of safety is very similar in both countries.',
      },
    },
    aboutPage: {
      hero: {
        heading: 'Supporting the medical journeys of students like us',
        description:
          'TUUTORIKESKUS Oy is a fully Finnish limited company founded in 2016 by three medical students. Our mission is simple: we want to help you achieve your dream.',
      },
      heading: 'About Us',
      sections: {
        experience: {
          title: 'Experience',
          description:
            'We are familiar with the entrance exams of Romanian medical universities. We know what they emphasise and what applicants should focus on while studying. Contact us if you want more information about medical universities in Romania.',
          imageAlt: 'Student at a Romanian university',
        },
        success: {
          title: 'Success story',
          description:
            'Seeing that others needed similar guidance, we decided to act. In summer 2017 we organised an intensive course where 11 out of 13 participants were offered a place at Romanian universities. This inspired us to support those pursuing international studies.',
          button: 'Read more',
          imageAlt: 'TuutoriKeskus success story',
        },
        courseBook: {
          title: 'Course book',
          description:
            'Designed by our teachers and based on previous entrance exams, drawing on insights from earlier questions. It is uniquely tailored to the needs of our courses and entrance exams with memory aids and visual explanations. This book is one of a kind and unavailable elsewhere.',
          button: 'Courses',
          imageAlt: 'Course book cover',
        },
      },
      modal: {
        close: 'Close additional information form',
        challengesTitle: 'Challenges',
        challengesText:
          'What made the process especially challenging was that we had just graduated from upper secondary school and had little time to prepare for that year’s entrance exam. The alternative was to take a gap year, losing valuable study time. Some of us had already done this and tried the exam several times without success. The odds of becoming a doctor in Finland were slim, so we decided to apply abroad, continue our studies without delay, and eventually graduate as doctors. We discovered an international Romanian medical university whose exam proved demanding, with an unfamiliar application process and limited study materials. We did not know what to study or which topics to prioritise. Anatomy and physiology are vast and difficult subjects. Fortunately, a friend already studying medicine in Romania guided us. Now it is our turn to do the same for others.',
        solutionTitle: 'Solution',
        solutionText:
          'We realised that applicants need guidance, coaching to succeed in the entrance exam, advice on paperwork, and help arranging accommodation. Without contacts in Romania the process is much more complicated. This insight led to our idea, piloted in summer 2017. Thirteen students joined a three-week intensive course, and eleven of them received offers from three different universities across Romania.',
      },
    },
    examPage: {
      hero: {
        heading: 'Entrance Exam Requirements',
        description:
          'Top universities in Romania do not require chemistry or physics. Entrance exams focus on anatomy and physiology, and the test is primarily oral.',
      },
      sections: {
        heading: 'The entrance exam consists of two stages:',
        english: {
          title: 'English language exam',
          paragraph1:
            'The exam assesses your level of English. According to experience, anyone who has completed general upper-secondary education in Finland performs well.',
          paragraph2:
            'During the interview you meet 2–3 professors. Questions are usually motivation-based (for example, why you deserve a place at the university). The written English test is made up of multiple-choice questions and a short reading task. In some schools you also write a motivational letter on site.',
        },
        anatomy: {
          title: 'Anatomy & Physiology exam',
          paragraph1:
            'The exam is oral and very broad. Professors may ask about any aspect of human anatomy or physiology. They assess not only your knowledge but also how professionally you present it.',
          paragraph2:
            'The oral entrance exam typically lasts all day, from 9 a.m. to 9 p.m., because every applicant must be interviewed. Make sure you know when it is your turn and when breaks take place, as the waiting periods can last several hours. Use the time to rest, refuel, or revise. The written entrance exam is familiar to Finnish students: it starts at 9 a.m. and ends at noon, and consists of multiple-choice questions on anatomy and physiology.',
        },
      },
    },
    videoCarousel: {
      heading: 'Romanian culture',
      description:
        'Romania has a long history and has preserved many traditions and cultural characteristics over the centuries. From its Roman roots onwards, Romania has been a crossroads of cultures and civilisations. This is reflected in the language, architecture, and traditional festivities.',
      controls: {
        previous: 'View the previous video',
        next: 'View the next video',
      },
      videos: {
        0: {
          title: 'Romanian culture – introduction video 1',
        },
        1: {
          title: 'Romanian culture – introduction video 2',
        },
        2: {
          title: 'Romanian culture – introduction video 3',
        },
      },
    },
  },
};


